import React from "react";
import { Box, Typography, DialogTitle, DialogContent } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import { IconButton } from "@ui";
import { DigitalLender, CustomerDeclarationEntry } from "@/shared/api/types";
import { LenderParentRecord } from "@/shared/api/services/lenderService";
import AddCompanyForm, { Company } from "@/components/AddCompanyForm";

interface AddCompanyDialogProps {
  onClose: () => void;
  ieMstrLenderData: LenderParentRecord[];
  digitalLenders: DigitalLender[];
  setCompanies?: React.Dispatch<React.SetStateAction<Company[]>>;
  freepostCreditorNamesData: DigitalLender[];
  declarationData: CustomerDeclarationEntry[];
  setCompanyShareLastUpdateDate?: React.Dispatch<React.SetStateAction<number>>;
  source: string;
  companies?: Company[];
  balanceAmount?: number;
}

const AddCompanyDialog: React.FC<AddCompanyDialogProps> = ({
  onClose,
  ieMstrLenderData: _ieMstrLenderData,
  digitalLenders,
  setCompanies,
  freepostCreditorNamesData,
  declarationData,
  setCompanyShareLastUpdateDate,
  source,
  companies,
  balanceAmount,
}) => {
  return (
    <Box data-testid="components-add-company-dialog-container-action" sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {/* Dialog Title */}
      <DialogTitle data-testid="components-add-company-dialog-header-action"
        sx={{
          position: "relative",
          px: { xs: "16px", md: "22px" },
          justifyContent: "space-between",
          display: "flex",
          alignItems: "center",
          // Divider inset 16px from each edge so it doesn't touch the border (June Patch #4)
          "&::after": {
            content: '""',
            position: "absolute",
            left: "16px",
            right: "16px",
            bottom: 0,
            borderBottom: "1px solid #e0e0e0",
          },
        }}
      >
        <Typography data-testid="components-add-company-dialog-text-add-company" variant="h5" sx={{ fontWeight: 600 }}>
          Add Company
        </Typography>

        <IconButton data-testid="components-add-company-dialog-btn-on-close"
          aria-label="close"
          onClick={onClose}
          sx={{
            color: "#9ca3af",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Dialog Content */}
      <DialogContent sx={{ pt: 3, px: { xs: "16px", md: "22px" }, flexGrow: 1, overflowY: "auto" }}>
        <AddCompanyForm
          ieMstrLenderData={_ieMstrLenderData}
          digitalLenders={digitalLenders}
          setCompanies={setCompanies}
          freepostCreditorNamesData={freepostCreditorNamesData}
          declarationData={declarationData}
          setCompanyShareLastUpdateDate={setCompanyShareLastUpdateDate}
          onBack={onClose}
          onSuccess={onClose}
          source={source}
          companies={companies}
          balanceAmount={balanceAmount}
        />
      </DialogContent>
    </Box>
  );
};

export default AddCompanyDialog;
